import { format, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd-MM-yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd-MM-yyyy HH:mm:ss');
}

export function fDateHourMinute(date) {
  return format(new Date(date), 'dd-MM-yyyy HH:mm');
}

export function fDateOrder(date) {
  return format(new Date(date), 'yyyyMMdd') + "0000#";
}

export function fDateServer(date) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fDateTimeServer(date) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd-MM-yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}
